
export enum EStatus {
  None,
  Draft,
  InProgress,
  Cancelled,
  Rejected,
  Finished
}
